(async function (domain, relativePath) {
	try {
		var scriptSrc = document.currentScript.src;
		var scriptPath = scriptSrc.substring(0, scriptSrc.lastIndexOf('/'));
		var url = scriptPath + '/' + relativePath;
		
		const response = await fetch(url);

		if (!response.ok) {
			throw new Error('Network response was not ok ' + response.statusText);
		}

		const translations = await response.json();

		var localeData = translations.locale_data[domain] || translations.locale_data.messages;

		localeData[""].domain = domain;
		wp.i18n.setLocaleData(localeData, domain);

	} catch (error) {
		console.error('Error loading JSON:', error);
	}
})("shop-ecards", '../languages/shop-ecards-fr_CA-zp4-shop-ecards-editor-script.json');
